import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";

const Toast = ({ type = "success", message, isOpen }) => {
  const isSuccess = type === "success";

  return (
    <>
      {isOpen && (
        <div
          className={`flex items-start sm:items-center fixed z-50 max-w-sm w-[90%] sm:w-full p-4 rounded shadow-md transition-all duration-300
          ${
            isSuccess
              ? "bg-green-50 text-green-800 border border-green-300"
              : "bg-red-50 text-red-800 border border-red-300"
          }
          bottom-4 left-1/2 transform -translate-x-1/2 sm:bottom-5 sm:left-5 sm:translate-x-0
        `}
        >
          <div className="mt-1 mr-3 text-xl">
            {isSuccess ? (
              <FaCheckCircle className="text-green-600" />
            ) : (
              <FaTimesCircle className="text-red-600" />
            )}
          </div>
          <div className="flex-1 text-sm">{message}</div>
        </div>
      )}
    </>
  );
};

export default Toast;
